import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import {ArrowRight} from 'lucide-react'

const games = [
  {
    name: "Apex Legends",
    description: "Discover Lifeline Bling, Heirloom weapons, and the rarest Prestige skins in the Outlands.",
    image: "https://static.lumi.new/41/4194f580ad35b1a6feb6cb7df2ca56ca.png",
    alt: "Apex Legends Bling Skins premium golden cosmetics",
    link: "/lifeline-bling",
    accent: "from-yellow-600/20 to-orange-600/10",
    borderAccent: "hover:border-yellow-600/50",
  },
  {
    name: "Fortnite",
    description: "The flashiest outfits, diamond-encrusted pickaxes, and gold-wrapped gliders in Battle Royale.",
    image: "https://static.lumi.new/0d/0dc4f7c8b033619da89b948856638e8b.png",
    alt: "Fortnite Bling Skins diamond and gold cosmetics",
    link: "/fortnite-bling",
    accent: "from-cyan-600/20 to-blue-600/10",
    borderAccent: "hover:border-cyan-600/50",
  },
  {
    name: "Valorant",
    description: "Premium weapon skins, Prestige gun buddies, and the most luxurious agent cosmetics.",
    image: "https://static.lumi.new/e2/e2aa6f983bc86740eabd0d233dc2d450.png",
    alt: "Valorant Bling Skins prestige weapon cosmetics",
    link: "/valorant-bling",
    accent: "from-red-600/20 to-pink-600/10",
    borderAccent: "hover:border-red-600/50",
  },
]

export default function FeaturedGames() {
  return (
    <section id="featured-games" className="relative py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight mb-4"
            style={{ fontFamily: "'Orbitron', sans-serif" }}
          >
            <span className="text-white">Featured </span>
            <span className="gold-shimmer">Games</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            Explore luxury cosmetics across the biggest titles in gaming.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {games.map((game, index) => (
            <motion.div
              key={game.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
            >
              <Link
                to={game.link}
                className={`card-lift group block rounded-2xl overflow-hidden border border-gray-800/50 ${game.borderAccent} bg-gray-950 transition-all`}
              >
                {/* Image */}
                <div className="relative aspect-square overflow-hidden">
                  <img
                    src={game.image}
                    alt={game.alt}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    loading="lazy"
                  />
                  <div className={`absolute inset-0 bg-gradient-to-t ${game.accent} opacity-0 group-hover:opacity-100 transition-opacity duration-500`} />
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-950 via-transparent to-transparent" />
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3
                    className="text-xl font-bold text-white uppercase tracking-wider mb-2 group-hover:text-yellow-400 transition-colors"
                    style={{ fontFamily: "'Orbitron', sans-serif" }}
                  >
                    {game.name}
                  </h3>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">
                    {game.description}
                  </p>
                  <span className="inline-flex items-center gap-2 text-yellow-500 text-sm font-semibold uppercase tracking-wider group-hover:gap-3 transition-all">
                    View Skins
                    <ArrowRight className="w-4 h-4" />
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
